import type { ConversationDigestApiModel as ConversationSummary } from "@noa/api-core";
import { useSessionId } from "@noa/client-store";

/** Whether the given conversation is the one currently selected in the store. Cheap — no query. */
export function useIsActiveConversation(conversationSummary: ConversationSummary): boolean {
  const selectedSessionId = useSessionId();
  return selectedSessionId === conversationSummary.session_id;
}
